import { render, staticRenderFns } from "./AvailableActivities.vue?vue&type=template&id=5005e280&scoped=true&"
import script from "./AvailableActivities.vue?vue&type=script&lang=js&"
export * from "./AvailableActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5005e280",
  null
  
)

export default component.exports